import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {IFilterQueryEr} from '../core/_models'
import {enableMapSet} from 'immer'

enableMapSet()
export interface LrFilterState {
  query: IFilterQueryEr
}

const initialState: IFilterQueryEr = {period: ''}

const erFilterSlice = createSlice({
  name: 'erFilter',
  initialState: initialState,
  reducers: {
    updateQuery(state, action: PayloadAction<Partial<IFilterQueryEr>>) {
      Object.assign(state, action.payload)
    },
    setQuery(state, action: PayloadAction<IFilterQueryEr>) {
      return action.payload
    },

    resetQuery(state) {
      delete state.rules
    },
  },
})

export const {resetQuery, setQuery, updateQuery} = erFilterSlice.actions
export default erFilterSlice.reducer
